import React from "react"
import { Textarea as RebassTextarea } from "rebass"

const Textarea = props => (
  <RebassTextarea
    {...props}
    rows={8}
    borderRadius={0}
    color="#4d4d4d"
    fontSize={[2, 3, 4]}
    mb={[0, 1, 2]}
  />
)

export default Textarea



// WEBPACK FOOTER //
// ./src/components/Textarea.js